// extracted by mini-css-extract-plugin
export default {"scale-selection":"DefaultQuestionPage_scale-selection__q+z3-"};